export default __webpack_public_path__ + "static/media/ZangXinCampMap.4893e156.jpg";